/**
 * Exposes build-time env values in the browser for debugging.
 * - In development (npm run dev): always set on window.__APP_ENV_DEBUG__
 * - In production build: only set when URL contains ?env_debug=1
 * Use in console: __APP_ENV_DEBUG__
 *
 * In DevTools Sources search, use:  __CXME_ENV__
 * The only match will show the inlined env (e.g. stage|app.stage...|api.stage...).
 *
 * Dumps all keys from import.meta.env except those whose names suggest sensitive data.
 */
const SENSITIVE_KEY_PATTERN = /password|secret|token|key|auth|credential|private|csrf/i;

function isSafeEnvKey(key: string): boolean {
    return !SENSITIVE_KEY_PATTERN.test(key);
}

const envDebug = (): void => {
    const isDev = import.meta.env.DEV;
    const showFromQuery =
        typeof window !== 'undefined' &&
        window.location.search.includes('env_debug=1');
    if (!isDev && !showFromQuery) return;

    const env = import.meta.env as Record<string, unknown>;
    const dumped: Record<string, unknown> = {};
    for (const key of Object.keys(env)) {
        if (isSafeEnvKey(key)) {
            dumped[key] = env[key];
        }
    }
    // Searchable string for DevTools Sources (built from dumped, no extra env reads)
    const __CXME_ENV__ = [
        dumped.VITE_APP_ENV,
        dumped.VITE_SSO_APP_ORIGIN,
        dumped.VITE_BOOMTOWN_API_HOST,
    ].map((v) => String(v ?? '')).join('|');
    dumped.__CXME_ENV__ = __CXME_ENV__;

    (window as unknown as { __APP_ENV_DEBUG__?: Record<string, unknown> }).__APP_ENV_DEBUG__ = dumped;
};

envDebug();
